
import React, { createContext, useContext, useMemo } from 'react';
import { useAppState } from 'src/state-management/state-provider';
import { UserRole } from 'src/api/Api';

interface AuthContextType {
  userId: string | undefined;
  isAdmin: boolean;
  isEmployee: boolean;
  isUser: boolean;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = useAppState();
  const { user } = state;

  const authContextValue = useMemo(() => {
    const isAuthenticated = !!user;
    const role = user?.role?.[0];
    return {
      userId: user?.user_id,
      isAuthenticated,
      isAdmin: role === UserRole.Admin,
      isEmployee: role === UserRole.Employee,
      isUser: role === UserRole.User,
    };
  }, [user]);

  return <AuthContext.Provider value={authContextValue}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
